export const categories = '/categories';
export const category = (id: number) => `/categories/${id}`;
